import React, { useState, useEffect } from 'react'
import UpdateForm from './UpdateForm';
import { Button, Typography } from '@mui/material';
import { Modal } from 'react-bootstrap'

export default function RateCodeSetup() {
    const [createNewFlag, setCreateNewFlag] = useState(false)
    const [lgShow, setLgShow] = useState(false);
    const [accessType, setAccessType] = useState('')

    //API call
    useEffect(() => {

        const loggedInUser = sessionStorage.getItem("user_token");
        const foundUser = JSON.parse(loggedInUser);

        if (foundUser.role_capabilities?.all_modules_access === true) {

            setAccessType('Edit');

        }
        else {

            setAccessType(foundUser.access['RateCode_Access Specifier']);
        }

    }, []);

    return (
        <>
            <div className="row">
                <div className="row my-3 ">
                    <div className="col-md-6">
                        <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
                            Rate Code {accessType === 'View' && "/ View Only Mode"}
                        </Typography>
                    </div>

                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
                        <Modal
                            size="lg"
                            show={lgShow}
                            onHide={() => setLgShow(false)}
                            aria-labelledby="example-modal-sizes-title-lg">
                            <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
                                <Modal.Title id="example-modal-sizes-title-lg" >
                                    Instructions to Add/Edit Rate Codes
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <h5>Add New</h5>
                                <ol>
                                    <li>Select Account Name from dropdown</li>
                                    <li>Enter the required fields</li>
                                    <li>Click on Submit button</li>
                                </ol>

                                <h5>Existing Rate Codes</h5>
                                <ol>
                                    <li>To view the existing Rate Codes select the Account Name from the dropdown</li>
                                </ol>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>

            {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}
        </>
    );
}
